// frontend/src/services/usuarioService.js
import axios from 'axios';

const API_URL = window.__CRM_API__ || `${window.location.origin}/api`;

export const usuarioService = {
  // Obtener todos los usuarios activos
  getAll: async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/usuarios`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      // Si falla, devolver array vacío
      return [];
    }
  },
};

export default usuarioService;
